import React from 'react';
import Icon from '../../../components/AppIcon';

const FinancialMetricCard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  trend = [], 
  period,
  onClick,
  className = '' 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const getChangeBackground = () => {
    if (changeType === 'positive') return 'bg-success/10';
    if (changeType === 'negative') return 'bg-error/10';
    return 'bg-muted/10';
  };

  return (
    <div 
      className={`bg-card border border-border rounded-lg p-6 card-shadow hover:shadow-lg transition-smooth cursor-pointer ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
            {period && (
              <span className="text-xs text-muted-foreground/70">{period}</span>
            )}
          </div>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="TrendingUp" size={14} className="text-muted-foreground" />
          <Icon name="MoreVertical" size={16} className="text-muted-foreground" />
        </div>
      </div>
      <div className="space-y-3">
        <div className="text-3xl font-bold text-foreground">{value}</div>
        
        {change && (
          <div className={`flex items-center space-x-2 text-sm px-2 py-1 rounded-md ${getChangeBackground()}`}>
            <Icon name={getChangeIcon()} size={14} className={getChangeColor()} />
            <span className={getChangeColor()}>{change}</span>
            <span className="text-muted-foreground">vs last period</span>
          </div>
        )}
        
        {trend?.length > 0 && (
          <div className="flex items-end space-x-1 mt-4 h-8">
            {trend?.map((point, index) => (
              <div
                key={index}
                className={`w-2 rounded-t-sm transition-all duration-300 ${
                  point > 70 ? 'bg-success h-full' : 
                  point > 50 ? 'bg-success/70 h-3/4' : 
                  point > 30 ? 'bg-warning h-1/2': 'bg-muted h-1/4'
                }`}
                style={{ 
                  opacity: index === trend?.length - 1 ? 1 : 0.4 + (index / trend?.length) * 0.6 
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FinancialMetricCard;